import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import SensorsTable from './SensorsTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const Sensors: FC = observer(() => {
  const {
    resellersStore: { selectedRowsSystems },
  } = useStores();

  return (
    <Container>
      <SensorsTable />
    </Container>
  );
});

export default Sensors;
